import { FulfillmentOrderAddressSchema } from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import {
  consolidationCartonLabelOriginSchema,
  consolidationCartonLabelParcelSchema,
  consolidationCartonPurchasedLabelSchema,
} from "@redotech/redo-fulfillment-operations-common/consolidation-carton-label";
import { RateSchema } from "@redotech/redo-fulfillment-rate-common/outbound-labels";
import * as z from "zod";
import { consolidationCartonLabelInputSchema } from "./consolidation-carton-label-common";

export const prepareConsolidationCartonLabel = {
  name: "prepareConsolidationCartonLabel" as const,
  mutates: true,
  input: consolidationCartonLabelInputSchema.extend({
    destination: FulfillmentOrderAddressSchema.optional(),
    origin: consolidationCartonLabelOriginSchema.optional(),
    parcel: consolidationCartonLabelParcelSchema.optional(),
  }),
  output: z.object({
    purchasedLabel: consolidationCartonPurchasedLabelSchema.nullable(),
    rates: z.array(RateSchema),
  }),
};
